export enum objTypes {
  string = 'string',
  number = 'number',
  date = 'date',
  boolean = 'boolean',
  valueInPair = 'valueInPair',
  arrayPair = 'arrayPair',
  json = 'json',
  json_has_other_option = 'json_has_other_option',
  percentage = 'percentage',
  text = 'text',
  timeFrameData = 'timeFrameData',
  relatedUnit = 'relatedUnit',
  productRelatedKey = 'productRelatedKey',
  supplyChainListData = 'supplyChainListData',
  facilityFormPreview = 'facilityFormPreview',
  supplierData = 'supplierData',
  status = 'status',
  comment = 'comment',
  phoneNumber = 'phoneNumber',
  userCreation = 'userCreation'
}
